// @ts-nocheck


import React from 'react';
import styled from 'styled-components';

import {
  Filter,
  FilterContainer,
  FilterItem,
  Selects,
  FilterButtonsContainer } from
'./../../../components';

import Field from './../../../components/card/Field';

const {
  MaintenanceWorkTypeSelect,
  RepairePlanSelect,
  OrderContractorTypeSelect
} = Selects;

const SpoilerContent = styled.div.withConfig({ displayName: "Filter__SpoilerContent", componentId: "sc-15yt9mj-0" })(["padding:16px;"]);















export const MaintenanceMatrixFilter = ({
  filter,
  cleanFilter,
  applyFilter
}) =>
<SpoilerContent>
    <FilterContainer>
      <Filter
      cleanFilter={cleanFilter}
      applyFilter={applyFilter}
      initialValues={filter}>

        {({
        values,
        changeValue,
        applyFilter,
        cleanFilter
      }) =>
      <>
            <FilterItem>
              <Field mBottomNone>
                <MaintenanceWorkTypeSelect
              placeholder="Выберите тип ремонта"
              size="small"
              onChange={(value) =>
              changeValue('maintenanceWorkTypeId', value)
              }
              value={values.maintenanceWorkTypeId} />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <RepairePlanSelect
              placeholder="График работ"
              size="small"
              onChange={(value) => changeValue('repairPlan', value)}
              value={values['repairPlan']} />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <OrderContractorTypeSelect
              placeholder="Способ выполнения"
              size="small"
              onChange={(value) => changeValue('orderContractorType', value)}
              value={values['orderContractorType']} />

              </Field>
            </FilterItem>

            <FilterButtonsContainer
          applyFilter={applyFilter}
          cleanFilter={cleanFilter} />

          </>
      }
      </Filter>
    </FilterContainer>
  </SpoilerContent>;


export default MaintenanceMatrixFilter;
